import React from 'react';
import { motion } from 'framer-motion';
export function Hero() {
  return <section className="relative min-h-screen w-full pt-12 md:pt-14 flex items-center justify-center overflow-hidden" data-id="element-43">
      {/* Background Image with Overlay */}
      <div className="absolute inset-0 z-0" data-id="element-44">
        <img src="https://cdn.magicpatterns.com/uploads/5VQc2WfyTLFVsEKvGChXP1/heylloyd-image-1771970893100.png" alt="Sala de aula de artes" className="w-full h-full object-cover" loading="eager" data-id="element-45" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/70 via-black/60 to-black/70" data-id="element-46" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 md:px-6 py-8 md:py-12 text-center" data-id="element-47">
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8
      }} className="inline-block mb-3 md:mb-4" data-id="element-48">
          <span className="bg-transparent text-yellow-400 px-3 md:px-6 py-1.5 md:py-2 rounded-full text-xs md:text-sm font-bold shadow-lg inline-flex items-center gap-1 md:gap-2 border-2 border-yellow-500" data-id="element-49">
            <span data-id="element-50">⭐</span>
            <span className="hidden sm:inline" data-id="element-51">
              O RECURSO #1 PARA PROFESSORES DE ARTES VISUAIS
            </span>
            <span className="sm:hidden" data-id="element-52">RECURSO #1 PARA PROFESSORES</span>
            <span data-id="element-53">⭐</span>
          </span>
        </motion.div>

        <motion.h1 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.2
      }} className="text-3xl md:text-5xl lg:text-6xl font-black text-white mb-1 md:mb-2 leading-tight" data-id="element-54">
          Mega Pacote Artes Visuais:
        </motion.h1>

        <motion.h2 initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.3
      }} className="text-4xl md:text-6xl lg:text-7xl font-black mb-4 md:mb-6 leading-tight" style={{
        color: '#d4af37'
      }} data-id="element-55">
          Planejamento Total
        </motion.h2>

        <motion.div initial={{
        opacity: 0,
        scale: 0.8
      }} animate={{
        opacity: 1,
        scale: 1,
        y: [0, -15, 0]
      }} transition={{
        opacity: {
          duration: 1,
          delay: 0.5
        },
        scale: {
          duration: 1,
          delay: 0.5
        },
        y: {
          duration: 3,
          repeat: Infinity,
          ease: 'easeInOut',
          delay: 1.5
        }
      }} className="mb-4 md:mb-6" data-id="element-56">
          <img src="https://cdn.magicpatterns.com/uploads/5fBJrVAE8RPVS1zoV1TS1d/P_(1080_x_600_px).png" alt="Mega Pacote Artes Visuais – 12 Tomos Completos" className="w-64 md:w-96 lg:w-[28rem] mx-auto h-auto" loading="eager" data-id="element-57" />
        </motion.div>

        <motion.p initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.7
      }} className="text-base md:text-xl lg:text-2xl text-white mb-5 md:mb-6 max-w-3xl mx-auto leading-snug md:leading-relaxed px-2 font-semibold" data-id="element-58">
          Aulas prontas para aplicar, organizadas por etapa escolar. Do Ensino
          Fundamental I ao Ensino Médio. Transforme suas aulas hoje mesmo.
        </motion.p>

        <motion.div initial={{
        opacity: 0,
        y: 30
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.9
      }} className="flex flex-col sm:flex-row items-center justify-center gap-3 md:gap-4" data-id="element-59">
          <motion.a href="#comprar" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="w-full sm:w-auto bg-red-700 text-white px-8 md:px-10 py-3.5 md:py-5 rounded-xl font-bold text-lg md:text-xl shadow-xl hover:bg-red-800 transition-all duration-300 inline-flex items-center justify-center gap-2" data-id="element-60">
            Quero Agora
            <span data-id="element-61">→</span>
          </motion.a>
          <motion.a href="#incluye" whileHover={{
          scale: 1.05
        }} whileTap={{
          scale: 0.95
        }} className="w-full sm:w-auto bg-black/40 backdrop-blur-sm text-white px-8 md:px-10 py-3.5 md:py-5 rounded-xl font-bold text-lg md:text-xl border-2 border-white/30 hover:bg-white/10 transition-all duration-300" data-id="element-62">
            Saiba Mais
          </motion.a>
        </motion.div>
      </div>

      {/* Social Proof Notification */}
      <motion.div initial={{
      opacity: 0,
      x: -100
    }} animate={{
      opacity: 1,
      x: 0
    }} transition={{
      delay: 2,
      duration: 0.5
    }} className="absolute bottom-4 md:bottom-8 left-4 md:left-8 bg-gray-900/90 backdrop-blur-sm text-white px-4 md:px-6 py-3 md:py-4 rounded-lg shadow-2xl max-w-xs hidden lg:block" data-id="element-63">
        <div className="flex items-start gap-3" data-id="element-64">
          <div className="w-10 h-10 bg-yellow-600 rounded-full flex items-center justify-center flex-shrink-0" data-id="element-65">
            <span className="text-xl" data-id="element-66">🛍️</span>
          </div>
          <div data-id="element-67">
            <p className="font-bold text-sm" data-id="element-68">
              <span className="text-yellow-400" data-id="element-69">Ana Paula</span> de São Paulo
            </p>
            <p className="text-xs text-gray-300" data-id="element-70">
              adquiriu o <span className="font-semibold" data-id="element-71">Mega Pacote</span>
            </p>
            <p className="text-xs text-gray-400 mt-1" data-id="element-72">Há 3 minutos</p>
          </div>
        </div>
      </motion.div>
    </section>;
}